<div>
	<canvas baseChart [datasets]="datasets" [labels]="labels" [options]="chartOptions" [colors]="chartColors" chartType="line" *ngIf="isReady" (chartClick)="dataClicked($event)" [ngClass]="{ 'hand': isClickable }"></canvas>
</div>